
import { Vue, Component, Prop, mixins } from 'nuxt-property-decorator'
import { format } from 'date-fns'
import Blocks from '~/mixins/blocks'
import ImageUrlS3 from '~/mixins/imageUrlS3'
import { CORE_GROUP } from '~/constants/blocks'

@Component
export default class PageLayoutArticle extends mixins(Blocks, ImageUrlS3) {
  @Prop({ required: true }) page: Record<string, any>

  blocks: Array<Record<string, any>> = []
  CORE_GROUP: string = CORE_GROUP

  created() {
    this.blocks = [...this.page?.blocks]
  }

  get date() {
    return format(new Date(this.page.date), 'MMMM d, yyyy')
  }
}
